import store from '@/vuex/store';
import { createClient } from 'hal-rest-client';

const api = createClient('https://zq81x6sw60.execute-api.eu-west-1.amazonaws.com/dev');

/**
 * @description
 * Access to the global DevPortal API.
 */
const AppsApi = {
  configure() {
    api.addHeader('Content-Type', 'application/json');
    api.addHeader('Authorization', store.getters.authToken);
  },

  /**
   * @description
   * Returns the list of all apps visible to the logged-in user.
   *
   * @returns {Promise<HalResource>}
   */
  async getApps() {
    // Or fetchArray -> test on real API. Probably we need to resolve collection as well.
    const resource = await api.fetchResource('/apps');
    // API returns collection resource with embedded apps resources inside it.
    return resource.prop('apps');
  },

  /**
   * @description
   * Creates new app on the server and returns created resource.
   *
   * @returns {Promise<HalResource>}
   */
  async createApp({ name, description }) {
    // TODO: We have to use full update cause POST method (create function) is not supported by
    // TODO: backend.
    return api.update(`/apps/${name}`, { description }, true);
  },
};

AppsApi.configure();
export default AppsApi;
